import { map, concat } from 'ramda';
import { theme, Theme } from 'config';
import { format } from 'd3-format';

import { Scale } from 'scenes/Report/Report.helper';

export type OverallLift = {
  control: number;
  exposed: number;
};

const { violet, softGray } = theme;
const overallLiftDefault = { control: 0, exposed: 0 };

const barTransformer = ({
  control,
  exposed,
}: OverallLift = overallLiftDefault) => [
  { x: 'Control', y: control, color: softGray },
  { x: 'Exposed', y: exposed, color: violet },
];

const liftPercentLabelMapping = (
  [{ x: controlX, y: controlY }, { x: exposedX, y: exposedY }]: Scale[],
  overallLiftPercent = 0,
) => [
  {
    x: controlY > exposedY ? exposedX : controlX,
    y: controlY > exposedY ? controlY : exposedY,
    label: format('.1%')(overallLiftPercent / 100),
    style: {
      fontSize: 18,
      stroke: violet,
      fill: violet,
      transform: 'translate(0 -24)',
    },
  },
];

const labelMapping = (formatType = '.2f') =>
  map<Scale, Scale>(({ x, y }: Scale) => ({
    x,
    y: y / 2,
    label: format(formatType)(y),
    style: {
      fontSize: 18,
      strokeWidth: 1,
      stroke: x === 'Control' ? violet : '#FFF',
      fill: x === 'Control' ? violet : '#FFF',
    },
  }));

const labelTransformer = (
  data: Scale[],
  overallLiftPercent?: number,
  formatType?: string,
): Scale[] =>
  concat(
    labelMapping(formatType)(data),
    liftPercentLabelMapping(data, overallLiftPercent),
  );

const lineTransformer = (
  overall: number,
): ((list: readonly { periodStart: string }[]) => { x: string; y: number }[]) =>
  map(({ periodStart }: { periodStart: string }) => ({
    x: periodStart,
    y: overall,
  }));

const liftByDateStyles = (theme: Theme) => ({
  liftHeader: {
    backgroundColor: `${theme.seafoamGreen} !important`,
    color: '#fff !important',
    padding: '.250rem !important',
    width: '7rem',
    margin: '0 auto !important',
  },
  metrics: {
    width: '100% !important',
  },
});

const tickFormatYAxis = (value: number): string => format('.1%')(value / 100);

export {
  barTransformer,
  labelTransformer,
  lineTransformer,
  liftByDateStyles,
  tickFormatYAxis,
};
